import { MaterialIcon } from '#/src/components/common/MaterialIcon';
import { styled } from '#/src/theme';

export const InfoGridIcon = styled(MaterialIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
}));
